import 'core-js/es/map';
import 'core-js/es/set';
import 'raf/polyfill';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';
import Axios from 'axios';
import { AxiosResponseErrorInterceptor } from './components/helpers/axios-response.interceptor';
import { AxiosRequestInterceptor } from './components/helpers/axios-request.interceptor';
import { getGuestId } from './common/helpers';
import { applyStoredSystemLanguage } from './common/system-language';

// Apply RTL/dir before React renders so the first paint matches the saved system
// language (Arabic / Hebrew / etc.) — avoids an LTR flash on reload.
applyStoredSystemLanguage();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const { REACT_APP_BASE_URL } = process.env;
Axios.defaults.baseURL = REACT_APP_BASE_URL;
getGuestId();
Axios.interceptors.request.use(AxiosRequestInterceptor);
Axios.interceptors.response.use(response => response, AxiosResponseErrorInterceptor);

root.render(
    <App />
);

reportWebVitals();
